module.exports = __webpack_public_path__ + "static/media/_kosovo.8700d003.png";